import Phaser from "phaser";
import LoadingScene from "@/dailyGames/Foraging/scenes/LoadingScene";
import RoundStartScene from "@/dailyGames/Foraging/scenes/RoundStartScene";
import QuestionScene from "@/dailyGames/Foraging/scenes/QuestionScene";
import PlayScene from "@/dailyGames/Foraging/scenes/PlayScene";
import AnsCorrectPlayScene from "@/dailyGames/Foraging/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/dailyGames/Foraging/scenes/AnsWrongPlayScene";
import BossScene from "@/dailyGames/Foraging/scenes/BossScene";
import LandingScene from "@/dailyGames/Foraging/scenes/LandingScene";
import Settings from "@/dailyGames/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
